<template>
  <div class="d-flex align-items-center subscriber-avatars">
    <template v-if="shownSubscriber.length">
      <subscriber-avatar
        v-for="subscriber in shownSubscriber"
        :key="subscriber.id"
        :small="small"
        :x-small="xSmall"
        :subscriber="subscriber"
        :default-text="defaultText"
      />

      <span
        v-if="showRemainingNumber && remainingSubscribersCount > 0"
        class="ml-1 remaining-count"
      >
        + {{ remainingSubscribersCount }}
      </span>
    </template>
    <subscriber-avatar
      v-else-if="defaultText"
      x-small
      :small="small"
      :default-text="defaultText"
    />
  </div>
</template>

<script>
import SubscriberAvatar from "@/components/SubscriberAvatar"

export default {
  components: {
    SubscriberAvatar
  },

  props: {
    subscribers: {
      type: Array,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    xSmall: {
      type: Boolean,
      default: false
    },
    defaultText: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: null
    },
    showRemainingNumber: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    shownSubscriber() {
      return this.limit === null
        ? this.subscribers
        : this.subscribers.slice(0, this.limit)
    },

    remainingSubscribersCount() {
      return Math.max(this.subscribers.length - this.shownSubscriber.length, 0)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.subscriber-avatars {
  .subscriber-avatar {
    margin-left: -1rem;
    border: 2px solid $color-ui--white;

    &:first-child {
      margin-left: 0;
    }
  }

  .remaining-count {
    color: $color-ui--black;
    font-size: 14px;
  }
}
</style>
